export default __webpack_public_path__ + "static/media/6.5bae70b6.jpg";